module.exports = __webpack_public_path__ + "img/ico-employment.ed7da5c1.svg";